import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconInterpretationsSizeS from './IconInterpretations_size_s';

const props: CreateIconArguments = {
  l: IconInterpretationsSizeS,
  m: IconInterpretationsSizeS,
  s: IconInterpretationsSizeS,
  xs: IconInterpretationsSizeS,
  name: 'IconInterpretations',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
